export const UPDATE_CLOSED_COUNT_LS_KEY = 'updateClosedCount';
